import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import ModalHeader from "../ModalHeader/ModalHeader";
import { useTheme } from "@emotion/react";
import { Grid } from "@mui/material";
import { useState } from "react";
import DeleteMessage from "../../../scenes/global/DeleteMessage/DeleteMessage";

export default function DyModalControl(props) {
  const theme = useTheme().palette.mode;
  const [warning, setWarning] = useState(false);
  const [modalIsFull, setModalIsFull] = useState(false);
  const [style, setStyle] = useState({
    position: "absolute",
    top: "50%",
    left: "50%",
    width: props.width ? props.width : "90%",
    height: props.height ? props.height : "auto",
    transition: "width .9s,height .9s !important",
    transform: "translate(-50%, -50%)",
    border: "0px solid #000",
    borderRadius: "16px",
    boxShadow:
      "0px 1px 18px 0px rgba(0, 0, 0, 0.12), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 3px 5px -1px rgba(0, 0, 0, 0.20)",
    p: 1,
  });

  const handleClose = () => {
    if (props.afterClose) {
      props.afterClose();
    }

    if (props.warningDisable) {
      props.off((prev) => ({ ...prev, mode: null, modal: false }));
    } else {
      setWarning(true);
    }
  };

  const agreeCloseModal = () => {
    props.off((prev) => ({
      mode: null,
      modal: false,
      showWarning: false,
    }));
  };
  const modalFullWidth = () => {
    setStyle({ ...style, width: "100%", height: "100vh" });
    setModalIsFull(true);
  };
  const modalExitFullWidth = () => {
    setStyle({
      ...style,
      width: props.width ? props.width : "90%",
      height: "auto",
    });
    setModalIsFull(false);
  };

  React.useLayoutEffect(() => {
    //when call Modal after give props bind modal Backgeround Color
    setStyle({
      ...style,
      background: theme === "dark" ? "#161B25" : "#F7FBFF",
    });
  }, [props]);

  return (
    <>
      {!props?.modalDisable && (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          sx={{ overflowY: "auto" }}
          open={props?.show}
          disableEnforceFocus
          onClose={(event, reason) => {
            if (reason === "escapeKeyDown") {
              handleClose();
            }
          }}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={props?.show}>
            <Grid item mx={"auto"} sx={style}>
              <Grid container>
                <Grid item xs={12}>
                  <ModalHeader
                    handleClose={handleClose}
                    title={props.title}
                    mode={props.mode}
                    modalFullWidth={modalFullWidth}
                    modalExitFullWidth={modalExitFullWidth}
                    modalIsFull={modalIsFull}
                  />
                </Grid>

                <Grid item xs={12}>
                  {props?.children}
                </Grid>
              </Grid>
            </Grid>
          </Fade>
        </Modal>
      )}
      {warning ? (
        <DeleteMessage
          showDeleteMessage={true}
          setShowDeleteMessage={setWarning}
          customText={"تغییرات ذخیره نشده است.فرم بسته شود؟"}
          agree={agreeCloseModal}
          typeBtn="header"
        />
      ) : props.showWarning ? (
        <DeleteMessage
          showDeleteMessage={true}
          setShowDeleteMessage={props.off}
          customText={"تغییرات ذخیره نشده است.فرم بسته شود؟"}
          agree={agreeCloseModal}
          typeBtn="footer"
        />
      ) : (
        ""
      )}
    </>
  );
}
/**==============================================
 *                javadBoroji     1402/10/30
 *    TODO:change close handler
 *    Description: زمانی که رو بستن مدال کلیلک می شود مدال وارنینگ به نمایش در می آید
 *
 *    new Props:showWarning
 *    descriptions: برای نمایش کامپونت وترنیگ روی دکمه دلخواه
 *      برای دکمه  بستن پایین مدال
 *=============================================**/
